/**
 * Credit Block client detail URL contract
 * -----------------------------
 * Path: `/credit-block/client/:clientId/:section`
 * - `clientId`: Gobodo/SF client key (URL-encoded when needed).
 * - `section`: slug from {@link CREDIT_BLOCK_CLIENT_DEFAULT_SECTION} and the maps below.
 *
 * Query:
 * - `subscriptionId` — preserved only on `subscription`; cleared when navigating to other sections
 *   (see client detail URL sync logic).
 *
 * Legacy: `?openMainTab=subscription` is rewritten to `/subscription` (+ optional `subscriptionId`).
 *
 * Slugs ↔ DynamicTabRenderer tab ids are defined in SLUG_TO_TAB_ID / TAB_ID_TO_SLUG below.
 */
const SLUG_TO_TAB_ID: Record<string, string> = {
  details: 'cb_account_detail',
  'credit-block': 'cb_client_details_tab',
  subscription: 'cb_subscription_workspace',
  activity: 'activity',
  notes: 'notes',
  files: 'files',
  'credit-report': 'credit-report',
  'lock-requests': 'lock-requests',
};

const TAB_ID_TO_SLUG: Record<string, string> = {
  cb_account_detail: 'details',
  details: 'details',
  cb_client_details_tab: 'credit-block',
  cb_subscription_workspace: 'subscription',
  activity: 'activity',
  notes: 'notes',
  files: 'files',
  'credit-report': 'credit-report',
  'lock-requests': 'lock-requests',
};

/** Matches first visible tab on `credit_block_client_detail` (Account / Details). */
export const CREDIT_BLOCK_CLIENT_DEFAULT_SECTION = 'details';

export function creditBlockClientSectionToTabId(section: string | undefined): string | null {
  const raw = String(section ?? '').trim().toLowerCase();
  if (!raw) return null;
  return SLUG_TO_TAB_ID[raw] ?? null;
}

export function creditBlockClientTabIdToSection(tabId: string | undefined): string | null {
  const raw = String(tabId ?? '').trim();
  if (!raw) return null;
  return TAB_ID_TO_SLUG[raw] ?? null;
}

export function isKnownCreditBlockClientSection(section: string | undefined): boolean {
  return creditBlockClientSectionToTabId(section) != null;
}
